import * as CardCrawl from "@ravalmatic/cardcrawl-engine";
import { Card } from "../Card";

export class CoinsEffect extends Phaser.GameObjects.Container {

    private totalCoins: number;

    constructor(card: Card) {
        
        super(card.scene);

        let x: number;
        let y: number;
        let finalX: number;
        let finalY: number;

        // TODO: CALCULAR LAS POSICIONES DE LAS MONEDAS EN FUNCION DE LA POSICION DE LA CARTA
        if (card.cardData.uiData.performedAction === CardCrawl.ActionType.SELL_CARD) {

            x = 70;
            y = -170;
            finalX = 25;
            finalY = -20;

        } else if (card.cardData.i === 0) {

            x = 45;
            y = -110;
            finalX = 530;
            finalY = 245;

        } else if (card.cardData.i === 2) {

            x = 70;
            y = -80;
            finalX = 100;
            finalY = 245;

        } else {

            x = 70;
            y = -80;
            finalX = 315;
            finalY = 8;
        }

        const n = 2 * card.cardData.lastValue;

        this.totalCoins = n;

        for (let i = 0; i < n; i ++) {

            const coin = new Phaser.GameObjects.Image(this.scene, x, y, "texture_atlas_1", "coin");
            coin.angle = Phaser.Math.Between(-12, 12);
            coin.scale = 0;
            this.add(coin);

            const angle = Phaser.Math.Between(0, 360);
            const dx = 50 * Math.cos(angle * Math.PI / 180);
            const dy = 50 * Math.sin(angle * Math.PI / 180);

            const chain = card.scene.tweens.chain({
                targets: coin,
                tweens: [
                    {
                        scaleX: 1.15,
                        scaleY: 1.15,
                        x: x + dx,
                        y: y + dy,
                        ease: Phaser.Math.Easing.Cubic.Out,
                        duration: 300,
                        delay: Math.random() * 250,
                    },
                    {
                        x: finalX,
                        y: finalY,
                        ease: Phaser.Math.Easing.Cubic.Out,
                        duration: 350,
                        delay: Math.random() * 200,
                    },
                    {
                        alpha: 0,
                        ease: Phaser.Math.Easing.Cubic.Out,
                        duration: 175,
                        onComplete: () => {
                            this.totalCoins--;
                            if (this.totalCoins === 0) {
                                this.destroy();
                            }
                        },
                        onCompleteScope: this
                    }
                ]
            });
            chain.play();
        }
    }
}
